import { useStore } from '@store/index';
import { Globe } from 'lucide-react';
import React from 'react';

import { Select, SelectContent, SelectItem, SelectTrigger } from '@/components/ui/select';
import { SimpleTooltip } from '@/components/ui/tooltip';
import { timeZoneLabels, timeZones } from '@/constants/date';

export function TimeZoneSelector() {
  const { setTimeZone, timeZone: selectedTimeZone } = useStore();

  return (
    <SimpleTooltip content={`Times shown in ${selectedTimeZone}`} side="bottom">
      <div>
        <Select value={selectedTimeZone} onValueChange={setTimeZone} aria-label="Select timezone">
          <SelectTrigger
            data-testid="timezone-switcher"
            className="h-8 px-2 gap-1.5 border border-input bg-background hover:bg-accent hover:text-accent-foreground focus:ring-0 focus:ring-offset-0 outline-hidden rounded-md [&_.lucide-chevron-down]:hidden"
          >
            <Globe className="h-4 w-4" />
            <span className="text-xs">{selectedTimeZone}</span>
          </SelectTrigger>

          <SelectContent>
            {timeZones.map(tz => (
              <SelectItem key={tz} value={tz}>
                {tz} ({timeZoneLabels[tz]})
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </SimpleTooltip>
  );
}
